import getField from './getField';
import isAlias from './isAlias';

const MAX_ALIAS_DEPTH = 5;

const getFieldRecursive = (
  root: Record<string, unknown>,
  path: string,
  separator = '/',
) => {
  const visitedAliases = new Map();

  let aliasOrField = getField(root, path, separator);

  visitedAliases.set(aliasOrField, true);

  for (
    let currDepth = 1;
    isAlias(aliasOrField, separator) && currDepth < MAX_ALIAS_DEPTH;
    currDepth++
  ) {
    aliasOrField = getField(root, aliasOrField, separator);

    if (visitedAliases.has(aliasOrField)) {
      return undefined; // in case of alias circural dependency we return undefined (ignore that alias)
    }

    visitedAliases.set(aliasOrField, true);
  }

  return aliasOrField;
};

export default getFieldRecursive;
